<script setup lang="ts">
import NotFoundLayout from '@/shared/views/Errors/NotFoundLayout.vue';
</script>

<template>
   <NotFoundLayout>
      <div class="text-center text-page pt-5 page-error-404">
         <h1 class="display-1 fw-bold text-primary">404</h1>
         <h2 class="mt-4 h2 fw-bold">Page Not Found</h2>
         <p class="mt-4 lead text-secondary">
            Oops! The page you are looking for does not exist.<br />It might have been moved or deleted.
         </p>
         <div class="mt-5 pb-5">
            <a href="/" class="btn nf-btn">
               Go Back Home
            </a>
         </div>
      </div>
   </NotFoundLayout>
</template>

<style lang="scss">
.page-error-404 .text-primary {
   color: #1e784c!important;
}
</style>

<style scoped lang="scss">
// Same look as the Admin/Teacher/Student login buttons (.homepage .btn in
// partial/homepage.scss) — that rule only applies while the "homepage" body
// class is set (toggled by LandingLayout, which this 404 page intentionally
// doesn't use), so it's replicated here as its own class instead of
// depending on that global, layout-specific mechanism.
.nf-btn {
   display: inline-block;
   white-space: nowrap;
   color: #fff;
   background-color: #44b6ae;
   border-radius: 0;

   &:hover {
      color: #fff;
      background-color: #3ca099;
   }
}
</style>
